(ns bec-cljs-common.components.image)

(defn img [props]
  [:img
   (merge
     {:style {:height "100%"}
      :on-error (fn [event]
                  (when (fn? (:on-error props)) 
                    ((:on-error props)))
                  (-> event .-target .-style .-display (set! "none")))}
     (when (map? props)
       (dissoc props :on-error)))])